<template>
  <div class="rect-switch" :class="[isActive && 'is-active', disabled && 'is-disabled']" @click="onSwitchClick">
    <input class="switch-input" type="checkbox" :name="name" :value="isActive"/>
    <div class="switch-core" :style="coreStyle">
      <label class="switch-label switch-label-left" :style="activeLabelStyle">{{ activeText || $t('common.label.yes') }}</label>
      <i class="switch-icon" :class="iconClass" :style="iconStyle"></i>
      <label class="switch-label switch-label-right" :style="inactiveLabelStyle">{{ inactiveText || $t('common.label.no') }}</label>
    </div>
  </div>
</template>

<script>
import { getTextColorByBgColor } from '@/utils/common'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: false
    },
    activeText: {
      required: false
    },
    inactiveText: {
      required: false
    },
    activeValue: {
      required: false,
      default: true
    },
    inactiveValue: {
      required: false,
      default: false
    },
    activeColor: {
      required: false,
      default: '#13ce66'
    },
    inactiveColor: {
      required: false,
      default: '#ff4949'
    },
    iconClass: {
      required: false
    },
    iconColor: {
      required: false,
      default: '#fff'
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    coreStyle () {
      return {
        transform: this.isActive ? `translateX(-${100 / 3}%)` : null
      }
    },
    activeLabelStyle () {
      return {
        color: getTextColorByBgColor(this.activeColor),
        borderColor: this.activeColor,
        backgroundColor: this.activeColor
      }
    },
    inactiveLabelStyle () {
      return {
        color: getTextColorByBgColor(this.inactiveColor),
        borderColor: this.inactiveColor,
        backgroundColor: this.inactiveColor
      }
    },
    iconStyle () {
      return {
        backgroundColor: this.iconColor,
        borderColor: this.isActive ? this.activeColor : this.inactiveColor
      }
    },
    valueWatcher () {
      return this.value
    }
  },
  created () {
    this.isActive = this.value === this.activeValue
  },
  methods: {
    onSwitchClick ($event) {
      if (this.disabled) {
        return
      }
      this.isActive = !this.isActive
    }
  },
  watch: {
    isActive () {
      this.$emit('change', this.isActive ? this.activeValue : this.inactiveValue)
    },
    valueWatcher () {
      this.isActive = this.value === this.activeValue
    }
  }
}
</script>

<style lang="scss" scoped>
.rect-switch {
  overflow: hidden;
  transition: border-color ease-in-out .3s;
  position: relative;

  &.is-disabled {
    .switch-core {
      .switch-icon, .switch-label {
        cursor: not-allowed;
      }
    }
  }

  .switch-input {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
    position: absolute;
  }

  .switch-core {
    display: flex;
    width: 150%;
    height: 100%;
    box-sizing: border-box;
    transition: all ease-in-out .3s;

    .switch-icon, .switch-label {
      flex: 1;
      cursor: pointer;
      border: 1px solid #0096cc;
    }

    .switch-label {
      text-align: center;
    }

    .switch-icon {

    }
  }
}
</style>
